import {
  PlanningBalancesByPeriodsQuery,
  PlanningBalancesQuery,
} from 'generated/resources/graphql'

type TimePlanningBalance = NonNullable<
  PlanningBalancesQuery['timePlanning']['balancesConnection']['nodes']
>[number]
type TimePlanningBalancesByPeriod = NonNullable<
  PlanningBalancesByPeriodsQuery['timePlanning']['balancesByPeriodsConnection']['nodes']
>[number]

import EmployeeCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/EmployeeCell'
import WorkAreaCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/WorkAreaCell'
import type { ShiftsRow, View } from 'modules/shift_management/lib/types'

interface Props {
  view: View
  shiftsRow: ShiftsRow
  balances?: TimePlanningBalance
  periodBalances?: TimePlanningBalancesByPeriod[]
}

export const FirstCell = ({ view, shiftsRow, balances, periodBalances }: Props) => {
  switch (view.groupType) {
    case 'areas':
      return <WorkAreaCell shiftsRow={shiftsRow} />

    default:
      return (
        <EmployeeCell shiftsRow={shiftsRow} balances={balances} periodBalances={periodBalances} />
      )
  }
}
